<template>
	<div class="wrap">
		<h2 class="sub--title text-center primary--text pt-13 mb-2">
			{{ $t('report.sub-title') }}
		</h2>
		<h1
			class="font-weight-bold main-title text-center mb-9"
			v-html="$t('report.title')"
		></h1>
		<div class="mb-5" style="width: 100%; overflow-x: auto">
			<div
				class="d-flex align-center justify-center"
				style="width: 100%; min-width: 414px"
			>
				<div
					class="button"
					@click="active = 1"
					:class="{ active: active === 1 }"
				>
					<div class="number">1</div>
					{{ $t('report.menu1') }}
				</div>
				<div
					class="button"
					@click="active = 2"
					:class="{ active: active === 2 }"
				>
					<div class="number">2</div>
					{{ $t('report.menu2') }}
				</div>
				<div
					class="button"
					@click="active = 3"
					:class="{ active: active === 3 }"
				>
					<div class="number">3</div>
					{{ $t('report.menu3') }}
				</div>
			</div>
		</div>
		<div class="mb-13 px-4">
			<log v-if="active === 1" :userDevice="userDevice" />
			<correction :userDevice="userDevice" v-if="active === 2" />
			<monthly-report v-if="active === 3" :userDevice="userDevice" />
		</div>
	</div>
</template>

<script>
import Log from './report/Log'
import Correction from './report/Correction.vue'
import MonthlyReport from './report/MonthlyReport.vue'

export default {
	components: {
		Log,
		Correction,
		MonthlyReport,
	},

	data() {
		return {
			active: 1,
		}
	},
	computed: {
		userDevice() {
			return this.$store.getters['userDevice']
		},
	},
}
</script>

<style lang="scss" scoped>
.wrap {
	background-color: #fff;
}

.button {
	padding: 10px 18px 10px 15px;
	object-fit: contain;
	border-radius: 23px;
	font-size: 16px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.56;
	letter-spacing: -0.5px;
	color: #78879d;
	.number {
		margin-right: 1px;
		display: inline-block;
		width: 22px;
		height: 22px;
		padding-left: 7px;
		border-radius: 50px;
		font-size: 14px;
		font-weight: bold;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.79;
		letter-spacing: -0.44px;
	}
}
.button.active {
	color: #006cf0;
	background-color: #fff;
	box-shadow: 0 10px 30px 0 rgba(33, 51, 82, 0.1);
	.number {
		background-color: #006cf0;
		color: #fff;
	}
}
</style>
